/* eslint-disable */
export default function(params) {
    return new Promise((resolve, reject) => {
        _getGroupNicheConfig({
            groupList: [
                {
                    groupName: '我的QQ群',
                    groupCode: params.ids
                }
            ]
        }).then(
            res => {
                if (window.parseInt(res.code) === 0 && res.data && res.data.records && res.data.records.length) {
                    let list = res.data.records[0].groupList.map(x=>{
                        return {
                            ...x,
                            id: x.uin
                        }
                    })
                    resolve(list);
                } else {
                    resolve([]);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
function _getGroupNicheConfig(params) {    
    return Vue.prototype.$_sAjax.post('/hb/selector/getTroopDetail', params);
}
